// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// // Define the form data type
// export interface MedicationIncidentFormData {
//   id?: string; 
//   date: string;
//   time: string;
//   location: string;
//   client_name: string;
//   support_worker_name: string;
//   medication_details: string;
//   nature_of_incident: string;
//   other_incident_details?: string;
//   description: string;
//   immediate_actions: string;
//   reported_to_healthcare: string;
//   healthcare_contact?: string;
//   recommendations: string;
//   support_worker_signature: string;
//   date_completed: string;
//   photo?: File | string;
//   client_email?: string;
// }

// // Define the state type
// export interface MedicationIncidentState {
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: MedicationIncidentState = {
//   loading: false,
//   message: null,
//   error: null
// };

// // Async thunk for posting medication incident data
// export const submitMedicationIncident = createAsyncThunk<
//   { message: string },
//   MedicationIncidentFormData,
//   { rejectValue: string }
// >('medicationIncident/submit', async (formData, { rejectWithValue, dispatch }) => {
//   try {
//     // Retrieve data from localStorage
//     const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//       projectId?: string;
//     };
//     const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//       selectedServiceTitle?: string;
//     };
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';

//     if (!project.projectId || !service.selectedServiceTitle || !client_email) {
//       return rejectWithValue('Missing project, service, or client information in localStorage');
//     }

//     let photoField: string = '';
//     if (formData.photo instanceof File) {
//       photoField = await convertFileToBase64(formData.photo);
//     } else if (typeof formData.photo === 'string') {
//       photoField = formData.photo;
//     }

//     const payload = {
//       id: formData.id || '', // Include id in payload
//       group_id: project.projectId,
//       service_name_id: service.selectedServiceTitle,
//       client_email,
//       date: formData.date,
//       time: formData.time,
//       location: formData.location,
//       client_name: formData.client_name,
//       support_worker_name: formData.support_worker_name,
//       medication_details: formData.medication_details,
//       nature_of_incident: formData.nature_of_incident,
//       other_incident_details: formData.other_incident_details || '',
//       description: formData.description,
//       immediate_actions: formData.immediate_actions,
//       reported_to_healthcare: formData.reported_to_healthcare,
//       healthcare_contact: formData.healthcare_contact || '',
//       recommendations: formData.recommendations,
//       support_worker_signature: formData.support_worker_signature,
//       date_completed: formData.date_completed,
//       photo: photoField
//     };

//     const response = await axiosInstance.post('/ndis/form/medication-incident', payload, {
//       headers: { 'Content-Type': 'application/json' }
//     });
//     await dispatch(fetchIncidents({ client_email })).unwrap();
//     return response.data;
//   } catch (error: any) {
//     return rejectWithValue(error.response?.data?.message || 'Failed to submit medication incident');
//   }
// });

// // Helper function to convert file to base64
// const convertFileToBase64 = (file: File): Promise<string> => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//     reader.readAsDataURL(file);
//   });
// };

// const medicationIncidentSlice = createSlice({
//   name: 'medicationIncident',
//   initialState,
//   reducers: {
//     clearMedicationIncidentState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(submitMedicationIncident.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(submitMedicationIncident.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message || 'Medication incident submitted successfully';
//         state.error = null;
//       })
//       .addCase(submitMedicationIncident.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearMedicationIncidentState } = medicationIncidentSlice.actions;
// export default medicationIncidentSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// Define the form data type
export interface MedicationIncidentFormData {
  id?: string;
  date: string;
  time: string;
  location: string;
  client_name: string;
  support_worker_name: string;
  medication_details: string;
  nature_of_incident: string;
  other_incident_details?: string;
  description: string;
  immediate_actions: string;
  reported_to_healthcare: string;
  healthcare_contact?: string;
  recommendations: string;
  support_worker_signature: string;
  date_completed: string;
  photo?: File | string;
  client_email?: string;
  resolved?: string; // Added resolved field
}

// Define the state type
export interface MedicationIncidentState {
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: MedicationIncidentState = {
  loading: false,
  message: null,
  error: null
};

// Helper function to convert file to base64
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

// Async thunk for posting medication incident data
export const submitMedicationIncident = createAsyncThunk<
  { message: string },
  MedicationIncidentFormData,
  { rejectValue: string }
>('medicationIncident/submit', async (formData, { rejectWithValue, dispatch }) => {
  try {
    // Retrieve data from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    if (!project.projectId || !service.selectedServiceTitle || !client_email) {
      return rejectWithValue('Missing project, service, or client information in localStorage');
    }

    let photoField: string = '';
    if (formData.photo instanceof File) {
      photoField = await convertFileToBase64(formData.photo);
    } else if (typeof formData.photo === 'string') {
      photoField = formData.photo;
    }

    const payload = {
      id: formData.id || '',
      group_id: project.projectId,
      service_name_id: service.selectedServiceTitle,
      client_email,
      date: formData.date,
      time: formData.time,
      location: formData.location,
      client_name: formData.client_name,
      support_worker_name: formData.support_worker_name,
      medication_details: formData.medication_details,
      nature_of_incident: formData.nature_of_incident,
      other_incident_details: formData.other_incident_details || '',
      description: formData.description,
      immediate_actions: formData.immediate_actions,
      reported_to_healthcare: formData.reported_to_healthcare,
      healthcare_contact: formData.healthcare_contact || '',
      recommendations: formData.recommendations,
      support_worker_signature: formData.support_worker_signature,
      date_completed: formData.date_completed,
      photo: photoField,
      resolved: formData.resolved || '' // Include resolved in payload
    };

    const response = await axiosInstance.post('/ndis/form/medication-incident', payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    await dispatch(fetchIncidents({ client_email })).unwrap();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to submit medication incident');
  }
});

const medicationIncidentSlice = createSlice({
  name: 'medicationIncident',
  initialState,
  reducers: {
    clearMedicationIncidentState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitMedicationIncident.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(submitMedicationIncident.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Medication incident submitted successfully';
        state.error = null;
      })
      .addCase(submitMedicationIncident.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearMedicationIncidentState } = medicationIncidentSlice.actions;
export default medicationIncidentSlice.reducer;